import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from 'src/app/auth/services/auth.service';
import { AuthConfigService } from 'src/app/auth/services/auth-config.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    public userLogin: AuthService,
    public router: Router,
    private authConfigService: AuthConfigService,
  ) {}
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.userLogin.isAuthenticated) {
      this.authConfigService.storeRequestedUrl(state.url);
      this.router.navigate(['/login']);
      return false;
    }
    return true;
  }
}
